var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[(_vm.initializing)?_c('div',{staticClass:"spinner-wrapper"},[_c('spinner',{attrs:{"large":"","main":"","label":_vm.$t('main.loading')}})],1):_c('router-view'),_c('modals-container'),_c('audio-player')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }